import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { tituloPantalla } from '../utils/titulosPantalla';

// Pone en la pestaña del navegador el nombre de la pantalla actual. No pinta nada.
export default function TituloPestana() {
  const { pathname } = useLocation();
  useEffect(() => { document.title = tituloPantalla(pathname); }, [pathname]);
  return null;
}
